
export const PLANS_GET_REQUEST = "PLANS_GET_REQUEST";
export const PLANS_GET_SUCCESS = "PLANS_GET_SUCCESS";
export const PLANS_GET_ERROR = "PLANS_GET_ERROR";